import React from 'react';

import RequestCard from 'components/Cards/RequestCard';
import LoaderCard from 'components/Cards/RequestCard/LoaderCard';
import EmptyList from 'components/EmptyList';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { RequestedItem } from 'models/requestHistory';

import { EmptyContainer, ListContainer } from '../styles';

interface Props {
  data?: RequestedItem[];
  isLoading: boolean;
  hasFilterTags: boolean;
}

const ListView = ({ data, isLoading, hasFilterTags }: Props) => {
  const { t } = useStoreTranslation();
  if (isLoading)
    return (
      <ListContainer>
        {Number(10)
          .toArray()
          .map((k) => (
            <LoaderCard key={k} />
          ))}
      </ListContainer>
    );

  if (!data)
    return (
      <EmptyContainer>
        <EmptyList
          description={t('requestHistory.emptyMessage')}
          image="/images/empty-awaiting-requests.svg"
          backgroundImage="/images/background-empty-awaiting-requests.svg"
        />
      </EmptyContainer>
    );
  return (
    <ListContainer className={hasFilterTags ? 'has-filters' : ''}>
      {data && data.map((item) => <RequestCard key={item.travelId} item={item} />)}
    </ListContainer>
  );
};
export default ListView;
